import { Helmet } from 'react-helmet-async';
import { StructuredDataProps } from './StructuredData.types';

export const StructuredData = ({ data }: StructuredDataProps) => {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};
